export const preloadImage = (src?: string) => {
  if (src) {
    const img = new Image();
    img.src = src;
  }
};
